import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => navigate("/sign-in"), 1800);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
  };

  if (!token) {
    return (
      <main className="max-w-md mx-auto px-6 py-16 text-center">
        <p className="font-display italic text-2xl">The seal is broken. Reset link is missing or invalid.</p>
        <Link to="/forgot-password" className="wax-button mt-6 inline-block">Request a new letter</Link>
      </main>
    );
  }

  return (
    <main className="max-w-md mx-auto px-6 py-16">
      <p className="label-overline text-center">A new password</p>
      <h1 className="font-display text-5xl text-center mt-3 mb-2">Reset</h1>
      <div className="fleuron mb-8">❦</div>

      {done ? (
        <div className="parchment-card text-center" data-testid="reset-success">
          <p className="font-display italic text-2xl">The wax is fresh.</p>
          <p className="font-body text-ink-iron mt-3">Returning you to sign in…</p>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="parchment-card space-y-5" data-testid="reset-form">
          <div>
            <label className="label-overline block mb-2">New password (8+ characters)</label>
            <input data-testid="reset-password" className="field" type="password" minLength={8} required value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          {error && <p className="text-wax-red text-sm italic">{error}</p>}
          <button data-testid="reset-submit" className="wax-button w-full">Set new password</button>
        </form>
      )}
    </main>
  );
}
